module.exports = __webpack_public_path__ + "static/media/logout.9dc669ca.svg";